import { CreateCompanyDto, IContacts, EMPTY_CONTACTS } from '@sr/dto';
import { FormikErrors } from 'formik';

export interface FormValues {
  name: string;
  companyContacts: IContacts;
  cityId: number | null;
  isClient: boolean;
  isSupplier: boolean;
  isMedia: boolean,
  isCompetitor: boolean,
  okvedIds: number[]
}

export const initialValues: FormValues = {
  name: '',
  cityId: null,
  companyContacts: EMPTY_CONTACTS,
  isClient: false,
  isSupplier: false,
  isMedia: false,
  isCompetitor: false,
  okvedIds: []
};

export const validate = async (values: FormValues) => {
  const errors: FormikErrors<FormValues> = {};

  const requiredMsg = 'Поле обязательно';
  if (!values.name) errors.name = requiredMsg;

  if (!values.isClient && !values.isSupplier && !values.isCompetitor && !values.isMedia) {
    errors.isClient = 'Выберите хотя бы одно значение';
    errors.isSupplier = 'Выберите хотя бы одно значение';
    errors.isCompetitor = 'Выберите хотя бы одно значение';
    errors.isMedia = 'Выберите хотя бы одно значение';
  }

  if (!values.cityId) {
    errors.cityId = 'Выберите хотя б один город';
  }

  if (!values.okvedIds || values.okvedIds.length <= 0) {
    errors.okvedIds = 'Выберите хотя б один ОКВЭД';
  }
  return errors;
};

export const toCreateCompanyDto = (formData: FormValues) => {
  if (!formData.cityId) {
    throw new Error('Город обязателен для заполнения');
  }
  const newCompanyDto: CreateCompanyDto = {
    name: formData.name,
    isClient: formData.isClient,
    isSupplier: formData.isSupplier,
    isMedia: formData.isMedia,
    isCompetitor: formData.isCompetitor,
    cityId: formData.cityId,
    contacts: {
      emails: formData.companyContacts.linkedEmails.map((x) => ({ email: x.email })),
      phones: formData.companyContacts.linkedPhones.map((x) => ({ phone: x.phone, ext: x.ext })),
      urls: formData.companyContacts.linkedUrls.map((x) => ({ url: x.url.url, urlTypeId: x.url.urlType.id }))
    },
    okvedIds: formData.okvedIds || [],
    okved: []
  };

  return newCompanyDto;
};
